import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators'


@Injectable({
  providedIn: 'root'
})
export class TeamStoreService {
  private baseUrl = environment.apiUrl;


  constructor(private http: HttpClient) { }

  createStoreTeam(OrgId, DepId) {
    return this.http.get(this.baseUrl + 'v1/teamstore/organization/artsv2/' + OrgId).pipe(
      map((response: any) => {
        const user = response;
        if (user) {
          return response;
        }
      })
    );
  }

  getProductDetails(prodId: any) {
    return this.http.get(this.baseUrl + 'v1/products/' + prodId).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  submitTeamStore(data: any) {
    return this.http.put(this.baseUrl + "v1/teamstore/userteamstore", data, { observe: "response" })
      .pipe(
        map((response: any) => {
          return response.body;
        })
      );
  }

  isUniqueTeamStore(data: any) {
    return this.http.post(this.baseUrl + "v1/teamstore/name/check/v1", data)
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }


}
